import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { Tag } from '@care/react-component-lib';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/getSearchResults';
import shuffleCaregiverSkills from '@/utils/shuffleCaregiverSkills';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';

interface CaregiverSkillsProps {
  caregiver: Caregiver;
}

const CaregiverSkills = ({ caregiver }: CaregiverSkillsProps) => {
  const caregiverProfile = caregiver.profiles?.commonCaregiverProfile;
  const qualities = caregiverProfile?.qualities || null;
  const { shuffleSeed = 1 } = usePageAttributes();
  const shuffledSkills = useMemo(
    () => shuffleCaregiverSkills(qualities, shuffleSeed),
    [qualities, shuffleSeed]
  );

  if (shuffledSkills.length === 0) {
    return null;
  }
  return (
    <Box alignItems="center" mt={1.5}>
      <Typography component="span" variant="body2" fontWeight="700">
        Skills:{' '}
      </Typography>
      {shuffledSkills.map((value) => {
        return (
          <Typography component="span" mr={1} key={`skill-tag-${value}`}>
            <Tag type="green">{value}</Tag>
          </Typography>
        );
      })}
    </Box>
  );
};

export default CaregiverSkills;
